<!-- Notifications non vues -->
@if (unreadNotificationsGroup) {
    <div class="notification-status-group">
        <h2 class="notification-status-header">{{unreadNotificationsGroup.status | translate}}</h2>
        @for (group of unreadNotificationsGroup.dateGroups; track group.date) {
            <div class="notification-group">
                <h3 class="notification-date-header">{{group.date}}</h3>
                @for (notification of group.notifications; track notification.id) {
                    <div class="notification-item" [ngClass]="{'unread': notification.read === false}" (click)="onSelect(notification)">
                        <div class="notification-type">
                            <mat-icon>{{notification.type}}</mat-icon>
                        </div>
                        <div class="notification-content">
                            <div class="notification-label">{{'notification.new_assignment' | translate}}</div>
                            <div class="notification-label">{{notification.label}}</div>
                            <div class="notification-label">{{'notification.lets_look_together' | translate}}</div>
                        </div>
                    </div>
                }
            </div>
        }
    </div>
}

<!-- Bouton pour afficher/masquer les notifications déjà vues -->
@if (hasReadNotifications) {
    <div class="toggle-read-notifications">
        <button mat-stroked-button (click)="toggleReadNotifications()" class="toggle-button">
            <mat-icon>{{ showReadNotifications ? 'expand_less' : 'expand_more' }}</mat-icon>
            {{ showReadNotifications ? ('notification.hide_read_notifications' | translate) : ('notification.show_read_notifications' | translate) }}
        </button>
    </div>
}

<!-- Notifications déjà vues (affichées seulement si showReadNotifications est true) -->
@if (readNotificationsGroup && showReadNotifications) {
    <div class="notification-status-group">
        <h2 class="notification-status-header">{{readNotificationsGroup.status | translate}}</h2>
        @for (group of readNotificationsGroup.dateGroups; track group.date) {
            <div class="notification-group">
                <h3 class="notification-date-header">{{group.date}}</h3>
                @for (notification of group.notifications; track notification.id) {
                    <div class="notification-item" [ngClass]="{'unread': notification.read === false}" (click)="onSelect(notification)">
                        <div class="notification-type">
                            <mat-icon>{{notification.type}}</mat-icon>
                        </div>
                        <div class="notification-content">
                            <div class="notification-label">{{'notification.new_assignment' | translate}}</div>
                            <div class="notification-label">{{notification.label}}</div>
                            <div class="notification-label">{{'notification.lets_look_together' | translate}}</div>
                        </div>
                    </div>
                }
            </div>
        }
    </div>
}

